import { useState, useContext, useCallback, useMemo, Fragment, useEffect } from "react";
import {
  Button,
  Dropdown,
} from "semantic-ui-react";
import { SharePrivilege, ShareStatus } from '@zoom/videosdk';
import { AuthContext } from "../../../../context/auth";
import { Col, Grid, Row, Spin, notification, Modal as AntdModal, message } from "antd";
// import useDbTrigger from "../../../../hooks/useDbtrigger";
import { get } from "../../../../utils/helpers";
//Header VC control images
import volume from "../../../../pages/Viewer/Images/newVolume.svg";
import trayRightIcon from "../../../../pages/Viewer/Images/tray-right-icon.svg";
import closeImg from '../../../../pages/Viewer/Images/close.svg';
import InvertLayout from "./InvertLayout";
import FullScreen from "./FullScreen";
import Reload from "./ReloadStream";
import ZoomContext from '../../../../pages/ZoomViewer/context/zoom-context';
import ConferenceSelection from "./ConferenceSelection";
import DrawingOptions from "./DrawingOptions";
import AudioToggle from "./AudioToggle";
import VideoToggle from "./VideoToggle";
import Volume from "./Volume";
import GlobalMute from "./GlobalMute";
import { useConferenceCommands } from "../../hooks/useConferenceCommands";
import Devices from './Devices';
import { useWhiteboardingStore } from "../../../../store";
import ProgressLoader from "../../../Common/ProgressLoader";
import NoiseCancellation from "./NoiseCancellation";
import "./styles.scss";



const HeaderTopVCControls = (props: any) => {
  const {
    admin_user_id,
    adminAccessCode,
    role,
    room_code,
    room_id,
    onScreenShareClick,
    onMenuOpen
  } = props

  const zmClient = useContext(ZoomContext);

  const { isEraser,
    isPencilCircle,
    isPencilLine,
    setEraserStateWithRef,
    setPencilLineStateWithRef,
    setPencilCircleStateWithRef
   } = useWhiteboardingStore()


  //popup
  const [showPopup, setShowPopup] = useState(false);

  // // Dominant Speaker
  const [showDominantSpeaker, setShowDominantSpeaker] = useState(false);
  
  const [showMultiStreamViewer, setShowMultiStreamViewer] = useState(false);

  // const [cameraDropdownOpen, setCameraDropdownOpen] = useState(false);

  const [sharePrivilege, setSharePrivileg] = useState(SharePrivilege.Unlocked);
  const { handelVideoConfEndAll, handelVideoConfEnd, endConferenceandRefreshCode, endorLeaveConferenceLoading } = useConferenceCommands(room_code,room_id,admin_user_id)

  //Drawing option
  const [showDrawingOption, setDrawingOption] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [overflowMenuOpen, setOverflowMenuOpen] = useState(false);
  const [hiddenIcons, setHiddenIcons] = useState<string[]>([]);
  const [mobileModalOpen, setMobileModalOpen] = useState(false);
  
  // Breakpoints: xs <576, sm ≥576, md ≥768, lg ≥992, xl ≥1200. Tablet from 576–1199 so 769 and 995 stay single row.
  const isMobile = get(screens, 'xs', true);
  const isTablet = get(screens, 'sm', false) && !get(screens, 'xl', false); // 576px–1199px: visible icons + more button
  const isDesktop = get(screens, 'xl', false); // Desktop: xl (1200px) and above only

  // Listen for event to close menus when right nav opens
  useEffect(() => {
    const handleCloseMenu = () => {
      setDrawingOption(false);
      setMobileModalOpen(false);
    };
    
    window.addEventListener('closeAnnotationMenu', handleCloseMenu);
    return () => {
      window.removeEventListener('closeAnnotationMenu', handleCloseMenu);
    };
  }, []);

  const onDrawingClick = () => {
    const newState = !showDrawingOption;
    setDrawingOption(newState);
    // Close right nav menu when annotation menu opens (not when closing)
    if (newState && onMenuOpen) {
      onMenuOpen();
    }
  };

  // eraser toggle function
  const eraserToggled = async () => {
    setEraserStateWithRef(!isEraser);
    setPencilCircleStateWithRef(false);
    setPencilLineStateWithRef(false);
  };


  // Clear WhiteBoard for all
  const clearWhiteBoardAll = async () => {
    setEraserStateWithRef(false);
    setPencilCircleStateWithRef(false);
    setPencilLineStateWithRef(false);
    const canvas: any = document.getElementById("canvas");
    if (canvas) {
      let context = canvas.getContext("2d");
      const canvasWidth = get(canvas, "width", 0);
      const canvasHeight = get(canvas, "height", 0);
      context.clearRect(0, 0, canvasWidth, canvasHeight);
    }
    // also send the clear function to others in the same zoom room
    const clear = true;
    const commandChannel = zmClient.getCommandClient();
    commandChannel.send(JSON.stringify({
      clear
    }))
  };

  // pencil toggle function - does NOT close the menu
  const pencilToggled = async () => {
    console.log('isPencilLine', isPencilLine)
    setEraserStateWithRef(false);
    setPencilCircleStateWithRef(false);
    setPencilLineStateWithRef(!isPencilLine);
    // Note: Removed setDrawingOption to keep menu open like eraser/delete
  };

  //circle toggled function - does NOT close the menu
  const circleToggled = async () => {
    setEraserStateWithRef(false);
    setPencilCircleStateWithRef(!isPencilCircle);
    setPencilLineStateWithRef(false);
    // Note: Removed setDrawingOption to keep menu open like eraser/delete
  };
 
  useEffect(() => {
    const alertUser  = (event:any) => {
      event.preventDefault()
      event.returnValue = ''
    }
    const handleEndConcert = (event:any) => {
      handelVideoConfEnd();
    };
    window.addEventListener('beforeunload', alertUser)
    window.addEventListener('unload', handleEndConcert)
    return () => {
      window.removeEventListener('beforeunload', alertUser)
      window.removeEventListener('unload', handleEndConcert)
    }
  }, [])

  // Icons shown in header on tablet before the "more" button (as width reduces, rest go in modal)
  const renderTabletVisibleIcons = (showDomSpeaker: boolean) => (
    <>
      <Reload
        showDomSpeaker={showDomSpeaker}
        admin_user_id={admin_user_id}
        adminCode={adminAccessCode}
      />
      {role === "host" ? <GlobalMute showDominantSpeaker={showDomSpeaker} /> : null}
      <DrawingOptions
        showDominantSpeaker={showDominantSpeaker}
        showMultiStreamViewer={showMultiStreamViewer}
        onDrawingClick={onDrawingClick}
        showDrawingOption={showDrawingOption}
        pencilToggled={pencilToggled}
        isPencilLine={isPencilLine}
        circleToggled={circleToggled}
        isPencilCircle={isPencilCircle}
        isEraser={isEraser}
        eraserToggled={eraserToggled}
        clearWhiteBoardAll={clearWhiteBoardAll}
        useOverlayForDrawingTools={isTablet}
      />
      <NoiseCancellation />
      <Volume showDominantSpeaker={showDominantSpeaker} />
    </>
  );

  // Tablet modal: only icons NOT in the header row (single row, no duplicates)
  const renderTabletModalContent = (showDomSpeaker: boolean) => (
    <div className="overflow-menu-content tablet-single-row">
      <AudioToggle showDominantSpeaker={showDomSpeaker} />
      <VideoToggle showDominantSpeaker={showDomSpeaker} />
      <Devices
        showDominantSpeaker={showDominantSpeaker}
        onScreenShareClick={onScreenShareClick}
      />
      <FullScreen />
      <InvertLayout />
    </div>
  );

  // Render components that should go in mobile modal
  const renderMobileModalContent = (iconName: string, showDomSpeaker: boolean) => {
    // Mobile (xs): 2 rows layout in modal
    if (isMobile) {
      return (
        <>
          <div className="miniheader-modal-row">
            <Volume showDominantSpeaker={showDominantSpeaker} />
            <Reload
              showDomSpeaker={showDomSpeaker}
              admin_user_id={admin_user_id}
              adminCode={adminAccessCode}
            />
            {role === "host" ? <GlobalMute showDominantSpeaker={showDominantSpeaker} /> : null}
            <NoiseCancellation />
          </div>
          <div className="miniheader-modal-row">
            <DrawingOptions
              showDominantSpeaker={showDominantSpeaker}
              showMultiStreamViewer={showMultiStreamViewer}
              onDrawingClick={onDrawingClick}
              showDrawingOption={showDrawingOption}
              pencilToggled={pencilToggled}
              isPencilLine={isPencilLine}
              circleToggled={circleToggled}
              isPencilCircle={isPencilCircle}
              isEraser={isEraser}
              eraserToggled={eraserToggled}
              clearWhiteBoardAll={clearWhiteBoardAll}
            />
            <AudioToggle showDominantSpeaker={showDominantSpeaker} />
            <VideoToggle showDominantSpeaker={showDominantSpeaker} />
            <Devices
              showDominantSpeaker={showDominantSpeaker}
              onScreenShareClick={onScreenShareClick}
            />
            <FullScreen />
            <InvertLayout />
          </div>
        </>
      );
    }

    // Desktop: all icons in horizontal layout (single row)
    return (
      <>
        <Reload
          showDomSpeaker={showDomSpeaker}
          admin_user_id={admin_user_id}
          adminCode={adminAccessCode}
        />
        {role === "host" ? <GlobalMute showDominantSpeaker={showDomSpeaker} /> : null}
        <DrawingOptions
          showDominantSpeaker={showDominantSpeaker}
          showMultiStreamViewer={showMultiStreamViewer}
          onDrawingClick={onDrawingClick}
          showDrawingOption={showDrawingOption}
          pencilToggled={pencilToggled}
          isPencilLine={isPencilLine}
          circleToggled={circleToggled}
          isPencilCircle={isPencilCircle}
          isEraser={isEraser}
          eraserToggled={eraserToggled}
          clearWhiteBoardAll={clearWhiteBoardAll}
        />
        <NoiseCancellation />
        <Volume showDominantSpeaker={showDominantSpeaker} />
        <AudioToggle showDominantSpeaker={showDominantSpeaker} />
        <VideoToggle showDominantSpeaker={showDominantSpeaker} />
        <Devices
          showDominantSpeaker={showDominantSpeaker}
          onScreenShareClick={onScreenShareClick}
        />
        <FullScreen />
        <InvertLayout />
      </>
    );
  };

  // Render overflow menu for mobile, tablet, or desktop
  const renderOverflowMenu = (showDomSpeaker: boolean) => {
    // Mobile (xs): only "more" button, opens modal with 2 rows
    if (isMobile) {
      return (
        <>
          <div
            className="top-menu-button-item"
            onClick={() => {
              const newState = !mobileModalOpen;
              setMobileModalOpen(newState);
              if (newState && onMenuOpen) onMenuOpen();
            }}
          >
            <img
              src={mobileModalOpen ? closeImg : trayRightIcon}
              alt=""
              style={{ filter: "brightness(1)", width: "20px", height: "20px" }}
            />
          </div>
          {mobileModalOpen && (
            <div className="overflow-menu-dropdown">
              <div className="overflow-menu-content mobile-rows-layout">
                {renderMobileModalContent("tools", showDomSpeaker)}
              </div>
            </div>
          )}
        </>
      );
    }

    // Tablet/iPad: visible icons + "more" button; modal opens with extra icons only
    if (isTablet) {
      return (
        <>
          {renderTabletVisibleIcons(showDomSpeaker)}
          <div
            className="top-menu-button-item"
            onClick={() => {
              const newState = !mobileModalOpen;
              setMobileModalOpen(newState);
              if (newState && onMenuOpen) onMenuOpen();
            }}
          >
            <img
              src={mobileModalOpen ? closeImg : trayRightIcon}
              alt=""
              style={{ filter: "brightness(1)", width: "20px", height: "20px" }}
            />
          </div>
        </>
      );
    }

    // Desktop: all icons directly, no modal
    return renderMobileModalContent("tools", showDomSpeaker);
  };

  // Tablet-only modal: icon strip (56x56, 4px gap, width fits content)
  const tabletModalContent = (
    <div className="overflow-menu-content tablet-single-row header-controls-modal-body">
      {renderTabletModalContent(showDominantSpeaker)}
    </div>
  );

  // Mobile modal: existing list-style with labels
  const mobileModalContent = (
    <div className="overflow-menu-content mobile-rows-layout">
      {renderMobileModalContent("tools", showDominantSpeaker)}
    </div>
  );

  return (
    <Fragment>
      <ProgressLoader loading={endorLeaveConferenceLoading} />
      <ConferenceSelection
        role={role}
        setShowPopup={setShowPopup}
        showPopup={showPopup}
        handelVideoConfEnd={handelVideoConfEnd}
        refreshRoomCode={endConferenceandRefreshCode}
        handelVideoConfEndAll={handelVideoConfEndAll} />
      
      <div className={`header-controls-row ${isTablet ? 'header-controls-row--tablet' : ''} ${isDesktop ? 'header-controls-row--desktop' : ''}`}>
        {renderOverflowMenu(showDominantSpeaker)}
      </div>

      {/* Tablet only: new icon-strip modal */}
      {isTablet && (
        <AntdModal
          open={mobileModalOpen}
          onCancel={() => setMobileModalOpen(false)}
          footer={null}
          title={null}
          closable={false}
          maskClosable={true}
          width={undefined}
          className="header-controls-overflow-modal"
          wrapClassName="header-controls-overflow-modal-wrap"
          bodyStyle={{ padding: 4 }}
          getContainer={() => document.body}
        >
          {tabletModalContent}
        </AntdModal>
      )}

      {/* Mobile: previous UI – custom dropdown (no Antd Modal) */}
      {/* {isMobile && mobileModalOpen && (
        <>
          <div
            className="header-controls-mobile-overlay"
            onClick={() => setMobileModalOpen(false)}
            aria-hidden
          />
          <div className="overflow-menu-dropdown mobile-overflow-dropdown">
            {mobileModalContent}
          </div>
        </>
      )} */}
    </Fragment>
  );
};

export default HeaderTopVCControls;
